// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".StatusTag_wrapper__TsAQ3 .ant-tag {\n  width: 92px; }\n  .StatusTag_wrapper__TsAQ3 .ant-tag.ant-tag-error {\n    padding-left: 12px; }\n  .StatusTag_wrapper__TsAQ3 .ant-tag > .anticon + span {\n    margin-left: 4px; }\n\n.StatusTag_wrapper__TsAQ3.StatusTag_loading__1PC0f .ant-tag > .anticon {\n  margin: 0; }\n\n.StatusTag_wrapper__TsAQ3.StatusTag_clickable__2NZRS {\n  cursor: pointer; }\n", ""]);
// Exports
exports.locals = {
	"wrapper": "StatusTag_wrapper__TsAQ3",
	"loading": "StatusTag_loading__1PC0f",
	"clickable": "StatusTag_clickable__2NZRS"
};
module.exports = exports;
